module.exports = global["bootbox"] = require("-!./bootbox.js");